import { Attributes, Validation } from '@singularsystems/neo-core';
import TemporalEntity from '../TemporalEntity';

export default class IssuerInvestmentPipeline extends TemporalEntity {
    static typeName = "IssuerInvestmentPipeline";

    constructor() {
        super();
        this.makeObservable();
    }

    public issuerInvestmentPipelineId: number = 0;

    public issuerInvestmentId: number = 0;

    public pipelineId: number = 0;

    public pipelinePercentage: number = 1;

    // Client only properties / methods

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
        rules.failWhen(c => c.pipelinePercentage < 0 || c.pipelinePercentage > 1,"Pipeline Percentage cannot be under 0% or over 100%");
    }

    public toString(): string {
        if (this.isNew) {
            return "New issuer investment pipeline";
        } else {
            return "Issuer Investment Pipeline";
        }
    }
}